import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IInvoiceUploadMethodOption } from '../../invoices.models';

@Component({
    selector: 'lsq-upload-invoices-options',
    templateUrl: './upload-invoices-options.component.html',
    styleUrls: ['./upload-invoices-options.component.scss']
})
export class UploadInvoicesOptionsComponent {
    @Input() public options: IInvoiceUploadMethodOption[] = [];
    @Output() public select = new EventEmitter<IInvoiceUploadMethodOption>();
}
